import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledModal = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  background-color: #fff;
  box-shadow: 24;
  padding: 2rem;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 400px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 600px;
  }
`;

export default StyledModal;
